import { HIDE_EDIT_PROFILE_MODAL, SHOW_EDIT_PROFILE_MODAL } from "../../constants/actions";

const initialState = {
    isModalVisible: false,
  };
  
  const editProfileModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case SHOW_EDIT_PROFILE_MODAL:
        return { ...state, isModalVisible: true };
      case HIDE_EDIT_PROFILE_MODAL:
        return { ...state, isModalVisible: false };
      default:
        return state;
    }
  };
  
  export default editProfileModalReducer;
  